import { _js } from '@ifixit/localize';
import { Image } from '@core-ds/icons/16';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const InsertImageButton = (props: any) => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.commands.activateMediaManager()}
         icon={<Image />}
         title={_js('Insert an image')}
      />
   );
};
